import {
  useCurrentWorkspace,
  useFileFilter,
  useSetFileFilter,
} from '@gripp/shared-logic';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { TextInput } from 'react-native-paper';
import { Colors } from '../../themes';
import { DebouncedTextInput } from '../forms';

export const FilesSearchInput = () => {
  const { t } = useTranslation();
  const { data: fileFilter } = useFileFilter();
  const { mutateAsync: setFileFilter } = useSetFileFilter();

  const currentWorkspaceId = useCurrentWorkspace();

  const [text, setText] = useState('');

  useEffect(() => {
    if (!text && fileFilter?.keyword) {
      setText(fileFilter.keyword);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileFilter?.keyword]);

  const updateSearch = async (term: string) => {
    if (!fileFilter) return;
    // fileFilter.workspaceId = currentWorkspaceId;
    fileFilter.keyword = term;
    await setFileFilter(fileFilter);
  };

  return (
    fileFilter && (
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceLength={3}
        debounceFunc={updateSearch}
        placeholder={t('file.filter.searchPlaceholder')}
        value={text}
        onBlur={() => null}
        onChangeText={(text) => setText(text)}
        left={<TextInput.Icon icon="magnify" color={Colors.grayFill} />}
        right={
          text ? (
            <TextInput.Icon
              icon="close"
              size={20}
              color={Colors.black}
              onPress={() => setText('')}
            />
          ) : (
            <View />
          )
        }
        height={44}
        outlineStyle={styles.inputStyle}
        disableInnerStyle={true}
      />
    )
  );
};

const styles = StyleSheet.create({
  inputStyle: {
    backgroundColor: Colors.white,
    borderColor: Colors.grayDivider,
    borderWidth: 1,
    borderRadius: 8,
  },
});
